import * as React from 'react';

import IconButton from '../icon-button';
import Icon from '../icon';
import {
	Root,
	ButtonStyled,
	ButtonSign,
	rootStyle,
} from './styled';


const handlers = [];

type CloseButtonProps = {
	appearance?: 'simple' | 'square';
	getNeedSkipEscape?: () => boolean;
	onClick: (e: React.SyntheticEvent) => void;
}

class CloseButton extends React.Component<CloseButtonProps> {
	static displayName = 'CloseButton';
	static defaultProps = {
		appearance: 'simple'
	};

	componentDidMount() {
		const { getNeedSkipEscape, onClick } = this.props;

		typeof getNeedSkipEscape === 'function' && handlers.push(onClick);
		document.addEventListener('keydown', this.handleKeyDown);
	}

	componentWillUnmount() {
		const { getNeedSkipEscape } = this.props;

		typeof getNeedSkipEscape === 'function' && handlers.pop();
		document.removeEventListener('keydown', this.handleKeyDown);
	}

	handleKeyDown = (e) => {
		const { onClick, getNeedSkipEscape } = this.props;

		if (e.keyCode === 27) {
			if (typeof getNeedSkipEscape === 'function' && !getNeedSkipEscape()) {
				onClick === handlers[handlers.length - 1] && onClick(e);
			} else {
				onClick(e);
			}
		}
	}

	render() {
		const {
			appearance,
			onClick
		} = this.props;

		if (appearance === 'square') {
			return (
				<Root>
					<ButtonStyled onClick={onClick}>
						<Icon type='clear' color='white' />
					</ButtonStyled>
					<ButtonSign>esc</ButtonSign>
				</Root>
			);
		}

		return (
			<IconButton
				style={{...rootStyle as React.CSSProperties}}
				onClick={onClick}>
				<Icon type={'clear'} />
			</IconButton>
		);
	}
}

export default CloseButton;
